import axios from '@/app/axios'
import bus from '@/app/bus'
import routing from '@/app/config/routing'
import router from '@/app/router'
import store from '@/app/store'
import Responses from '@/app/utils/responses'
import AuthRequest from '@/users/requests/auth-request'
import AuthResponse from '@/users/responses/auth-response'
import AuthModule from '@/users/store/auth-module'
import { getModule } from 'vuex-module-decorators'
import { AxiosResponse } from 'axios'
import i18n from '@/app/plugins/i18n'
import { Dictionary } from 'vue-router/types/router'

class AuthService {
  public async loginAsync(request: AuthRequest) {
    const res = await axios.post<AuthResponse>('auth/login', request)
    return this.handleAuthResponse(res)
  }

  public async impersonate(request: AuthRequest) {
    const res = await axios.post<AuthResponse>('auth/impersonate', request)
    return this.handleAuthResponse(res)
  }

  public async resetPasswordAsync(
    email: string,
    token: string,
    password: string
  ) {
    const res = await axios.post('auth/password/reset', {
      email,
      token,
      password,
    })
    return [res.data.success, res.data.message]
  }

  public async sendPasswordResetLinkAsync(email: string) {
    await axios.post('auth/sendPasswordResetLink', { email })
  }

  public async logoutAsync() {
    const authModule = getModule(AuthModule, store)
    await axios.post('auth/logout')
    authModule.logout()
    // Browser History cannot be flushed.
    router.push({
      name: routing.logoutRedirect,
      params: { lang: i18n.locale },
    })
  }

  public authenticated() {
    const authModule = getModule(AuthModule, store)
    return authModule.authenticated
  }

  public user() {
    const authModule = getModule(AuthModule, store)
    return authModule.user
  }

  // public displayName() {
  //   const authModule = getModule(AuthModule, store)
  //   return authModule.displayName
  // }

  public tenant() {
    const authModule = getModule(AuthModule, store)
    return authModule.tenant
  }

  public isInRole(role: string) {
    const authModule = getModule(AuthModule, store)
    return authModule.roles.some((r) => r === role)
  }

  public isNotInRole(role: string) {
    return this.isInRole(role) == false
  }

  public isInAnyRole(roles: string[]) {
    return roles.some(this.isInRole)
  }

  public isInNeitherRole(roles: string[]) {
    return this.isInAnyRole(roles) === false
  }

  // TODO: Permissions

  private handleAuthResponse(res: AxiosResponse<AuthResponse>) {
    const authModule = getModule(AuthModule, store)
    const response = Responses.obj(res)
    if (response !== null) {
      if (response.authenticated && response.token !== null) {
        authModule.login(response)
        bus.$emit('auth.logged-in')
        this.redirect()
      }
      return response
    }
    return null
  }

  private redirect() {
    const authModule = getModule(AuthModule, store)
    const role = authModule.roles.length > 0 ? authModule.roles[0] : 'DEFAULT'

    const redirectUrl = router.currentRoute.params.redirectUrl
    if (redirectUrl !== undefined) {
      router.push({ name: redirectUrl })
      return
    }

    const routes: Dictionary<string> = routing.loginDefaultRedirect
    if (routes[role]) {
      router.push({
        name: routes[role],
        params: { lang: i18n.locale },
      })
    } else {
      router.push({
        name: routes['DEFAULT'],
        params: { lang: i18n.locale },
      })
    }
  }
}

export default new AuthService()
